export const EMAIL_CAPTURE_CAMPAIGN = 'email_capture_modal';

export const EMAIL_CAPTURE_COOKIE = 'no_email_capture_modal';

export const EMAIL_CAPTURE_OFFER_CODE = 'Color_FSOrder';

export const EMAIL_SOURCE = 'popup_email_capture';

export const EXPERIMENT_CONFIGS = {
  new_modal_delay: {
    name: 'Email Capture Delay Part 2',
    configs: {
      A: {
        delay: 15000,
      },
      B: {
        delay: 3000,
      },
    },
  },
};

export const EMAIL_CAPTURE_DEFAULT_CONFIG = {
  title: {
    default: 'FREE SHIPPING',
    success: 'CONGRATS, FREE SHIPPING APPLIED',
  },
  description: {
    default: `Share your email & we'll treat you to <span class="bold">free shipping</span> on your first order.`,
    success: 'Free shipping will be automatically applied during checkout on your first purchase.',
  },
  conditions: 'Free standard shipping on first purchase. Valid for new customers only. Unsubscribe anytime.',
  code: 'Color_FSOrder',
  email_source: 'popup_email_capture',
};

export const EMAIL_CAPTURE_PATH_CONFIGS = [
  {
    config: {
      title: {
        default: '$10 OFF YOUR FIRST SERVICE',
        success: 'CONGRATS, $10 OFF APPLIED',
      },
      description: {
        default: `Share your email & we'll treat you to <span class="bold">$10 off</span> your first service at our hair color bars.`,
        success: '$10 off will be automatically applied during checkout on your first service.',
      },
      conditions: '$10 off on first hair color bar service. Valid for new customers only. Unsubscribe anytime.',
      code: 'BOOKING10',
      email_source: 'HCB_email_capture',
    },
    paths: ['/colorbar'],
  },
];

export const EMAIL_CAPTURE_ALLOWED_PATHS = [];

export const EMAIL_CAPTURE_BANNED_PATHS = [
  '/account',
  '/careers',
  '/cart',
  '/checkout',
  '/color-advisor',
  '/color-advisor-ulta',
  '/color-crew',
  '/compare-shades',
  '/confirmation',
  '/email',
  '/shop/hair-color',
  '/support',
  '/term',
  '/signIn',
  '/signin',
  '/booking',
  '/refer',
  '/share',
  '/tv',
  '/coloristcooperative',
  '/coloristaffiliates',
  '/coloristcooperative-raf',
  '/coloristcooperative-terms-and-conditions',
  '/quiz-on-q',
  '/color-consultation',
];

export const EMAIL_CAPTURE_RULES = {
  isFirstTimeVisitor: true,
  hasCapturedEmail: false,
  hasEmail: false,
  hasDismissedModal: false,
  hasPurchaseHistory: false,
};
